import DatePicker from 'react-datepicker';
import React from 'react';
import { getRegistrationMaxDate } from '../../utils/dateHelper';
import en from 'date-fns/locale/en-GB';
import th from 'date-fns/locale/th';

const DatePickerRegistration = (props) => {
    const {
        input,
        placeholder,
        meta: { touched, error },
    } = props;

    return (
        <>
            <DatePicker
                className="theme-light datepickerSelect"
                dateFormat="yyyy-MM-dd"
                selected={input.value}
                selectsStart
                onChange={input.onChange}
                maxDate={getRegistrationMaxDate()}
                disabledKeyboardNavigation
                placeholderText={placeholder}
                withPortal
                dropdownMode="select"
                isClearable
                showMonthDropdown
                showYearDropdown
                peekNextMonth
                locale={localStorage.getItem('language') === 'en' ? en : th}
            />
            <div className="form__form-group-input-wrap">
                {touched && error && (
                    <span className="form__form-group-error">{error}</span>
                )}
            </div>
        </>
    );
};

DatePickerRegistration.defaultProps = {
    placeholder: '',
    meta: {
        touched: false,
        error: '',
    },
};

export default DatePickerRegistration;
